
import ImportContactsTwoToneIcon from "@mui/icons-material/ImportContactsTwoTone";
export function IconSubject({ sx, ...props }) {
  const normalizedSx = Array.isArray(sx) ? sx : sx ? [sx] : [];

  return (
    <ImportContactsTwoToneIcon
      {...props}
      sx={[
        ...normalizedSx,
        {
          "& path[opacity='.3'], & path[opacity='0.3']": {
            opacity: 0,
          },
        },
      ]}
    />
  );
}
export { IconSubject as Subject };

export { default as IconAdd } from "@mui/icons-material/AddOutlined";
export { default as IconArrowLeft } from "@mui/icons-material/KeyboardBackspaceOutlined";
export { default as IconArrowOutward } from "@mui/icons-material/CallMadeOutlined";
export { default as IconArrowRight } from "@mui/icons-material/EastOutlined";
export { default as IconArchive } from "@mui/icons-material/ArchiveOutlined";
export { default as IconAttachment } from "@mui/icons-material/AttachFileOutlined";
export { default as IconBlock } from "@mui/icons-material/BlockOutlined";
export { default as IconCalculate } from "@mui/icons-material/PlayCircleOutlined";
export { default as IconCheck } from "@mui/icons-material/CheckRounded";
export { default as IconChevronDown } from "@mui/icons-material/KeyboardArrowDownOutlined";
export { default as IconChevronLeft } from "@mui/icons-material/KeyboardArrowLeftOutlined";
export { default as IconChevronRight } from "@mui/icons-material/KeyboardArrowRightOutlined";
export { default as IconChevronUp } from "@mui/icons-material/KeyboardArrowUpOutlined";
export { default as IconClose } from "@mui/icons-material/CloseRounded";
export { default as IconColor } from "@mui/icons-material/ColorLensOutlined";
export { default as IconDelete } from "@mui/icons-material/DeleteOutlined";
export { default as IconDrag } from "@mui/icons-material/DragIndicatorOutlined";
export { default as IconEdit } from "@mui/icons-material/EditOutlined";
export { default as IconError } from "@mui/icons-material/HighlightOff";
export { default as IconExport } from "@mui/icons-material/FileUploadOutlined";
export { default as IconFilter } from "@mui/icons-material/FilterAltOutlined";
export { default as IconForm } from "@mui/icons-material/DescriptionOutlined";
export { default as IconGlobal } from "@mui/icons-material/LanguageOutlined";
export { default as IconHelp } from "@mui/icons-material/HelpOutlineOutlined";
export { default as IconHome } from "@mui/icons-material/HomeOutlined";
export { default as IconHoliday } from "@mui/icons-material/BeachAccessOutlined";
export { default as IconImport } from "@mui/icons-material/FileDownloadOutlined";
export { default as IconInfo } from "@mui/icons-material/InfoOutlined";
export { default as IconAvailability } from "@mui/icons-material/EventAvailableOutlined";
export { default as IconRecurringCalendar } from "@mui/icons-material/EventRepeatOutlined";
export { default as IconLock } from "@mui/icons-material/LockOutlined";
export { default as IconLocation } from "@mui/icons-material/LocationOnOutlined";
export { default as IconLogOut } from "@mui/icons-material/LogoutOutlined";
export { default as IconLessonAllocation } from "@mui/icons-material/AppRegistrationOutlined";
export { default as IconLessonPattern } from "@mui/icons-material/ViewAgendaOutlined";
export { default as IconMenu } from "@mui/icons-material/MoreVertOutlined";
export { default as IconMail } from "@mui/icons-material/EmailOutlined";
export { default as IconManualRegistration } from "@mui/icons-material/EditNoteOutlined";
export { default as IconRemove } from "@mui/icons-material/RemoveOutlined";
export { default as IconNote } from "@mui/icons-material/CommentOutlined";
export { default as IconNotification } from "@mui/icons-material/NotificationsOutlined";
export { default as IconProfile } from "@mui/icons-material/AccountCircle";
export { default as IconPreview } from "@mui/icons-material/VisibilityOutlined";
export { default as IconRoom } from "@mui/icons-material/MeetingRoomOutlined";
export { default as IconRules } from "@mui/icons-material/GppMaybeOutlined";
export { default as IconSave } from "@mui/icons-material/Done";
export { default as IconSchoolClass } from "@mui/icons-material/GroupOutlined";
export { default as IconSearch } from "@mui/icons-material/Search";
export { default as IconSettings } from "@mui/icons-material/SettingsOutlined";
export { default as IconSort } from "@mui/icons-material/UnfoldMoreOutlined";
export { default as IconStudent } from "@mui/icons-material/SchoolOutlined";
export { default as IconSuccess } from "@mui/icons-material/CheckCircleOutlined";
export { default as IconSwitch } from "@mui/icons-material/SwapHorizOutlined";
export { default as IconTeacher } from "@mui/icons-material/PersonOutlineOutlined";
export { default as IconTime } from "@mui/icons-material/AccessTimeOutlined";
export { default as IconTrendingUp } from "@mui/icons-material/TrendingUpOutlined";
export { default as IconTimetable } from "@mui/icons-material/EventNoteOutlined";
export { default as IconUndo } from "@mui/icons-material/Undo";
export { default as IconWarning } from "@mui/icons-material/WarningAmber";

// Legacy aliases for existing non-DS consumers. New DS code should use the `Icon...` names.
export { default as Add } from "@mui/icons-material/AddOutlined";
export { default as ArrowLeft } from "@mui/icons-material/KeyboardBackspaceOutlined";
export { default as ArrowOutward } from "@mui/icons-material/CallMadeOutlined";
export { default as ArrowRight } from "@mui/icons-material/EastOutlined";
export { default as Archive } from "@mui/icons-material/ArchiveOutlined";
export { default as Block } from "@mui/icons-material/BlockOutlined";
export { default as Calculate } from "@mui/icons-material/PlayCircleOutlined";
export { default as Check } from "@mui/icons-material/CheckRounded";
export { default as ChevronDown } from "@mui/icons-material/KeyboardArrowDownOutlined";
export { default as ChevronLeft } from "@mui/icons-material/KeyboardArrowLeftOutlined";
export { default as ChevronRight } from "@mui/icons-material/KeyboardArrowRightOutlined";
export { default as ChevronUp } from "@mui/icons-material/KeyboardArrowUpOutlined";
export { default as Close } from "@mui/icons-material/CloseRounded";
export { default as Color } from "@mui/icons-material/ColorLensOutlined";
export { default as Delete } from "@mui/icons-material/DeleteOutlined";
export { default as Edit } from "@mui/icons-material/EditOutlined";
export { default as Error } from "@mui/icons-material/HighlightOff";
export { default as Export } from "@mui/icons-material/FileUploadOutlined";
export { default as Filter } from "@mui/icons-material/FilterAltOutlined";
export { default as Form } from "@mui/icons-material/DescriptionOutlined";
export { default as Global } from "@mui/icons-material/LanguageOutlined";
export { default as Help } from "@mui/icons-material/HelpOutlineOutlined";
export { default as Home } from "@mui/icons-material/HomeOutlined";
export { default as Import } from "@mui/icons-material/FileDownloadOutlined";
export { default as Info } from "@mui/icons-material/InfoOutlined";
export { default as Availability } from "@mui/icons-material/EventAvailableOutlined";
export { default as Lock } from "@mui/icons-material/LockOutlined";
export { default as LogOut } from "@mui/icons-material/LogoutOutlined";
export { default as LessonAllocation } from "@mui/icons-material/AppRegistrationOutlined";
export { default as LessonPattern } from "@mui/icons-material/ViewAgendaOutlined";
export { default as Menu } from "@mui/icons-material/MoreVertOutlined";
export { default as Mail } from "@mui/icons-material/EmailOutlined";
export { default as ManualRegistration } from "@mui/icons-material/EditNoteOutlined";
export { default as Remove } from "@mui/icons-material/RemoveOutlined";
export { default as Note } from "@mui/icons-material/CommentOutlined";
export { default as Notification } from "@mui/icons-material/NotificationsOutlined";
export { default as Profile } from "@mui/icons-material/AccountCircle";
export { default as Preview } from "@mui/icons-material/VisibilityOutlined";
export { default as Room } from "@mui/icons-material/MeetingRoomOutlined";
export { default as Rules } from "@mui/icons-material/GppMaybeOutlined";
export { default as Save } from "@mui/icons-material/Done";
export { default as SchoolClass } from "@mui/icons-material/GroupOutlined";
export { default as Search } from "@mui/icons-material/Search";
export { default as Settings } from "@mui/icons-material/SettingsOutlined";
export { default as Sort } from "@mui/icons-material/UnfoldMoreOutlined";
export { default as Student } from "@mui/icons-material/SchoolOutlined";
export { default as Success } from "@mui/icons-material/CheckCircleOutlined";
export { default as Teacher } from "@mui/icons-material/PersonOutlineOutlined";
export { default as Time } from "@mui/icons-material/AccessTimeOutlined";
export { default as Timetable } from "@mui/icons-material/EventNoteOutlined";
export { default as Undo } from "@mui/icons-material/Undo";
export { default as Warning } from "@mui/icons-material/WarningAmber";
